<template>
  <div class="bg-gray">
    <navigation-bar :mode="'Admin'"></navigation-bar>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12" style="padding-top:20px;">
            <div class="row">
              <div class="col-xs-12 col-sm-12 text-left">
                <div class="row">
                  <div class="col-sm-12">
                    <h1 style="float:left;">Listing</h1>
                  </div>
                </div>
                <hr>
                <div v-if="store.state.listing.user" class="row">
                  <div class="col-sm-12">
                    <h3>User</h3>
                    <p>Name: {{store.state.listing.user.first_name}} {{store.state.listing.user.last_name}}</p>
                    <p>Email: {{store.state.listing.user.email}}</p>
                  </div>
                </div>
                <hr>
              <div class="row">
                <div class="col-sm-12">
                  <h3>Details</h3>
                </div>
                <div style="margin-top:20px;text-align:left;" v-for="field in store.state.listing.fields" class="col-sm-6" :key="field.id">
                  <h4>{{field.name}}</h4>
                  <a :href="'mailto:' + utils.findFieldValue(store.state.listing,field.name)" v-if="field.type == 'Email'">{{utils.findFieldValue(store.state.listing,field.name)}}</a>
                  <a target="_blank" :href="utils.findFieldValue(store.state.listing,field.name)" v-else-if="field.type == 'Website'">{{utils.findFieldValue(store.state.listing,field.name)}}</a>
                  <p v-else>{{utils.findFieldValue(store.state.listing,field.name)}}</p>
                </div>
                <div style="margin-top:20px;text-align:left;" class="col-sm-6">
                  <h4>Price</h4>
                  <p>
                    <span v-if="store.state.listing.price != 'free'">$</span>
                    {{store.state.listing.price}}</p>
                </div>
                <div style="margin-top:20px;text-align:left;" class="col-sm-6">
                  <h4>City</h4>
                  <p>
                    {{store.state.listing.city}}</p>
                </div>
                <div style="margin-top:20px;text-align:left;" class="col-sm-6">
                  <h4>State</h4>
                  <p>
                    {{store.state.listing.state}}</p>
                </div>
                <div style="margin-top:20px;text-align:left;" class="col-sm-6">
                  <h4>Listing Locations</h4>
                  <p v-for="(state,idx) in store.state.listing.states" :key="`state_${idx}`">
                    {{state.state}}</p>
                </div>
              </div>
              </div>
            </div>
            <br>
        </div>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from '../nav/NavigationBar.vue'
import DashboardFooter from '../nav/Footer'
import Utils from '@/Utils/Utils'
import Navigator from '@/router/navigator'
import AdminListingDetailsStore from './AdminListingDetailsStore'
import AdminPermissionsUtils from './AdminPermissionsUtils'
import moment from 'moment'

export default {
  name: 'AdminListingDetails',
  components: {
    NavigationBar,
    DashboardFooter
  },
  data () {
    return {
      nav: Navigator,
      store: AdminListingDetailsStore,
      adminUtils: AdminPermissionsUtils,
      utils: Utils
    }
  },
  mounted () {
    this.adminUtils.authorize((userId) => {
      this.store.state.currentUserId = userId;
      if(this.$route.params.listingId && this.$route.params.listingId != 'undefined'){
        this.store.state.listingId = this.$route.params.listingId
        this.getListing();
      }else{
        this.nav.goAdminListings(this);
      }
    },(err) => {
      this.nav.goAdminLogin(this);
    })
  },
  methods: {
    getListing: function() {
      let self = this
      this.store.getListing((data) => {
      }, (err) => {
        this.$toasted.show(err, { type: 'error', duration: 2500 })
      })
    },
    dateListed: function(listing) {
      return moment(listing.dateListed).format("MM/DD/YYYY")
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/AdminListingDetails.vue